/* eslint-disable */


import { SIDEBAR_WIDTH } from '../../Constants/Sidebar/Sidebar.constants';

/**
 * Create styles for `<Sidebar />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Sidebar />` styles
 */
const sidebarStyles = ({ theme }) => ({
  closed: {
    marginLeft: SIDEBAR_WIDTH * -1,
  },
  paper: {
    backgroundColor: theme.palette.grey[100],
    height: `100%`,
    overflowX: `hidden`,
    overflowY: `auto`,
    width: SIDEBAR_WIDTH,
    [theme.breakpoints.up(`md`)]: {
      position: `relative`,
    },
  },
  root: {
    display: `flex`,
    flexDirection: `column`,
    flexGrow: 1,
    transition: theme.transitions.create([`margin`], {
      duration: theme.transitions.duration.enteringScreen,
      easing: theme.transitions.easing.easeOut,
    }),
  },
});

export default sidebarStyles;
